import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'
import type { TFunction } from 'i18next'

import type { IntradayOrderRow } from '~/hooks/bidding/useListBiddingIntradayOrders'
import { convertAreaLabel } from '~/models/area'
import { isIntradayMarketOrder } from '~/models/intradayOrderMethod'
import { decimalVolumeToMw } from '~/pages/IntradayBidding/models/convertIntradayBidsFromOrders'

/**
 * 承認判断に出す 1 札の申請内容サマリ (AC-BIN-097: 対象コマ・エリア・売買・量・価格)。
 * 価格・量が取れない札は 0 でなく `—` を出す (= 承認判断の画面に実在しそうな偽の数値を
 * 出さない)。 数量はコマ別 MW (issue #4285)。
 * 成行の札 (AC-BIN-004d) は価格を持たず内部で "0" を運ぶので、 価格の代わりに「成行」 と
 * 出す (入札一覧の価格列と同じ表記。 0 円の指値に見せない)。
 */
export const intradayApprovalDetailLine = (
  t: TFunction,
  order: Pick<
    IntradayOrderRow,
    | 'timeCode'
    | 'areaCode'
    | 'direction'
    | 'priceYenPerKwh'
    | 'volumeMwh'
    | 'orderMethod'
  >,
): string => {
  const params = {
    koma: order.timeCode,
    area: convertAreaLabel(order.areaCode),
    side: t(
      order.direction === Side.BUY
        ? 'page:biddingSpot.side.buy'
        : 'page:biddingSpot.side.sell',
    ),
    volume: decimalVolumeToMw(order.volumeMwh) ?? '—',
  }
  return isIntradayMarketOrder(order)
    ? t('page:biddingIntraday.approvalAction.approveDetailMarket', params)
    : t('page:biddingIntraday.approvalAction.approveDetail', {
        ...params,
        price: order.priceYenPerKwh?.value ?? '—',
      })
}
